<template>
    <div>
        <div v-if="showItem=='one'">
            <div v-if="currentRow.topnum==0" @click="isTop('',currentRow)" style="font-size: 14px;
            font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;
            color: #1890FF;cursor: pointer;">置顶</div>

            <div v-else @click="isTop('',currentRow)" style="font-size: 14px;font-family: PingFang SC-Regular, PingFang SC;
            font-weight: 400;color:#1890FF;cursor: pointer;">取消置顶</div>
        </div>
        <div v-if="showItem=='many'" style="display:initial">
            <el-button class="top-button"  size="small" @click="isTop('top','')">置顶</el-button>
            <el-button class="top-button" size="small" @click="isTop('cancelTop','')">取消置顶</el-button>
        </div>
    </div>
</template>

<script>
    import { mapState} from "vuex";
    export default {
        name:'eip-top',
        props:['currentRow','topList','topType','showItem'],
        data(){
            return{

            }
        },
        computed: mapState({
            userId: (state) => state.user.currentUserDetail.user.id
        }),
        methods:{
            isTop(type,row){
                let data;
                if(row){
                    data = {list:[{userId:this.userId,gdh:row.workorderno || row.workOrderNo}],
                                type:row.topnum?'cancelTop':'top',
                                topType:this.topType
                    }
                }else{
                    if(!this.topList.length){
                    let tip = type=="top"?"置顶":"取消置顶";
                    this.$message.warning("请选择要"+tip+"的流程");
                    return;
                    }else{
                    let flag = false;
                    for(let i=0;i<this.topList.length;i++){
                        if((type == 'top'&&!this.topList[i].topnum)||(type == 'cancelTop'&&this.topList[i].topnum)){
                        flag = true;
                        break;
                        }
                    }
                    if(!flag){
                        let tip = type=="top"?"置顶":"取消置顶";
                        this.$message.warning("请选择要"+tip+"的流程");
                        return;
                    }
                    }
                    let arr = [];
                    this.topList.forEach((e,i)=>{
                    if(type == 'top' && !e.topnum){
                        arr.push({userId:this.userId,gdh:e.gdh})
                    }else if(type == 'cancelTop' && e.topnum){
                        arr.push({userId:this.userId,gdh:e.gdh})
                    }
                    })
                    data = {list:arr,type:type,topType:this.topType};
                }
                this.$store
                    .dispatch("storeProcess/isTop", data)
                    .then((res) => {
                    if(res.state){
                        this.$emit('search','find')
                    }
                    });
            },
        }
    }
</script>
<style scoped>
    .top-button{
        margin-left: 10px;
    }
</style>